import moment from 'moment';
import { ModalController } from '../common/modal.controller.js';
import { Column12, Column6, Column4, Row } from '../common/forms/layout.js';
import { OTVOREN, UOBRADI } from '../radniNalog/statusi.js';

class DashboardController {
    constructor($state, AppConfiguration, DS) {
        let app = AppConfiguration();
        this.entityRN = app.getEntity('dashboard');
        this.fields = this.entityRN.listView().fields();
        this.datastore = () => {
            return DS;
        };

        this.listActions = this.entityRN.listView().listActions();
        this.$state = $state;
        this.params = {
            limit: 10,
            offset: 0,
            status: UOBRADI
        };
    }

    $onInit() {
        this.otvoreniNalozi = [];
        this.refreshState(this.params);
        this.getForToday();
        this.mode = 'danas';
    }

    refreshState(params) {
        let DS = this.datastore();
        DS.findAll('RadniNalog', { limit: 20, offset: 0, status: OTVOREN }, { bypassCache: true }).then(response => {
            this.otvoreniNalozi = response;
        });

        DS.findAll('Ordinacija')
            .then(response => {
                return DS.findAll('RadniNalog', params, { bypassCache: true });
            })
            .then(response => {
                this.entries = response;
            });
    }

    edit(item) {
        this.$state.go('radniNalog.details', { id: item.id });
    }

    onFilter(item) {
        this.params.search = item;
        this.refreshState(this.params);
    }

    getForToday() {
        this.mode = 'danas';
        this.days = [moment().format('YYYY-MM-DD')];
        this.day = this.days[0];
    }

    getForNextDay() {
        this.mode = 'sutra';
        this.days = [
            moment()
                .add(1, 'days')
                .format('YYYY-MM-DD')
        ];
        this.day = this.days[0];
    }

    getForDay(day) {
        this.mode = 'custom';
        this.days = [day];
        this.day = this.days[0];
    }

    getForWeek() {
        this.mode = 'tjedan';
        this.days = [
            moment().format('YYYY-MM-DD'),
            moment()
                .add(1, 'days')
                .format('YYYY-MM-DD'),
            moment()
                .add(2, 'days')
                .format('YYYY-MM-DD'),
            moment()
                .add(3, 'days')
                .format('YYYY-MM-DD'),
            moment()
                .add(4, 'days')
                .format('YYYY-MM-DD'),
            moment()
                .add(5, 'days')
                .format('YYYY-MM-DD')
        ];
        this.day = null;
        this.datum_od = this.days[0];
        this.datum_do = this.days[5];
        // let element = $('#faze-for-day');
        // element.siblings()
        //             // .addClass('opacity-0')
        //             // .addClass('stagger')
        //             .addClass('animated-panel')
        //             .addClass('zoomOut')
        //             .addClass('hide');
        // element.removeClass('col-lg-6');
        // element.addClass('col-lg-12');
        // debugger;
    }
}

DashboardController.$inject = ['$state', 'AppConfiguration', 'DS'];

export { DashboardController };



// WEBPACK FOOTER //
// ./app/components/dashboard/dashboard.controller.js